/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { observer } from 'mobx-react';

import Grid from '@mui/material/Grid';

import { useStyles } from './styles';
import useWidgetTheme from '../../../commons/widgetTheme';
import Header from '../header';
import Footer from '../dialogFooter';
import Banner from '../banner';

import { useCommonUIStyles } from '../../../commons/uiStyles';

function WidgetDialog (props) {
    const {
        ref,
        isOauthTalking = false,
        isShowCloseButton = true,
        isShowBackButton = true,
        goToBackPage =  () => {},
        children = null,
        viewAnimation = false,
        initStyles = {},
        ...others
    } = props;

    const {
        widget,
        widgetTheme,
    } = useWidgetTheme({
    });

    const {
        commonUIStyles,
    } = useCommonUIStyles({
        widget,
        widgetTheme,
    });

    const classes = useStyles({
        viewAnimation,
        initStyles,
        commonUIStyles,
    });
 
    return (
        <React.Fragment>
            <Grid
                ref={ref}
                id="content"
                className={classNames([classes.dialogBox, 'ecal-dialog'])}
                { ...others }
            >
                <Banner />
                {!isOauthTalking && (
                    <Header
                        widget={widget}
                        widgetTheme={widgetTheme}
                        isShowCloseButton={isShowCloseButton}
                        isShowBackButton={isShowBackButton}
                        goToBackPage={goToBackPage}
                    />
                )}
                <Grid className={classes.dialogContent}>
                    { children }
                </Grid>
                {!isOauthTalking && (
                    <Footer
                        widget={widget}
                        widgetTheme={widgetTheme}
                    />
                )}
            </Grid>           
        </React.Fragment>
    );
}

WidgetDialog.propTypes = {
    isOauthTalking: PropTypes.bool,
    isShowCloseButton: PropTypes.bool,
    isShowBackButton: PropTypes.bool,
    goToBackPage: PropTypes.func,
    children: PropTypes.any,
    viewAnimation: PropTypes.bool,
    initStyles: PropTypes.any,
};

export default observer(WidgetDialog);